export class TriggerEvent extends CustomEvent<boolean> {
  constructor(on: boolean = true) {
    super('trigger', { detail: on });
  }
}
